import { useState, useEffect } from "react";
import {ShoppingCart, Menu, ArrowRight, Package} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import logo from "@/assets/logo-shadow.webp";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { totalItems } = useCart();

  const location = useLocation();
  const isProductPage = location.pathname.startsWith("/san-pham") || location.pathname === "/cart" || location.pathname === "/thanh-toan" || location.pathname === "/lich-su-mua-hang";

  useEffect(() => {
  let ticking = false;

  const onScroll = () => {
    if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "TRANG CHỦ", to: "/" },
    { label: "THƯƠNG HIỆU", to: "/thuong-hieu" },
    { label: "SẢN PHẨM", to: "/san-pham/tat-ca" },
    { label: "SHARING BLOG", to: "/sharing-blog" },
    { label: "CHÍNH SÁCH", to: "/chinh-sach" },
    { label: "LIÊN HỆ", to: "/lien-he" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 flex flex-col bg-primary-foreground transition-shadow duration-300 ${
        scrolled ? "shadow-lg" : ""
      }`}
    >
      <div className="flex w-full items-center justify-center bg-muted/50 text-muted-foreground py-1 px-4 text-[10px] font-normal tracking-tight border-b border-border/50">
        <span className="text-center opacity-70"><b>Lưu ý:</b> <i>Đây là website thuộc dự án môn học Digital Marketing, mọi nội dung trên trang không phục vụ cho mục đích thương mại.</i></span>
      </div>
      <div className="container mx-auto flex items-center justify-between px-6 py-1 md:py-3">
        <Link to="/" 
          className="flex-shrink-0">
          <img src={logo} 
          width="75"
          height="42"
          alt="Memys"
          className="h-6 w-auto md:h-8 lg:h-10 px-2"
           />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="text-primary text-sm tracking-wider hover:text-accent transition-colors duration-200"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-4">
          <Link
            to="/lich-su-mua-hang"
            className="text-primary hover:text-accent transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Lịch sử mua hàng"
          >
            <Package size={20} />
          </Link>
          <Link to="/cart"
          
          className="text-primary hover:text-accent transition-colors relative min-w-[44px] min-h-[44px] flex items-center justify-center" aria-label="Cart">
            <ShoppingCart size={20} />
            <span className="absolute top-1 right-1 w-4 h-4 bg-discount text-primary-foreground text-[10px] rounded-full flex items-center justify-center">
              {totalItems}
            </span>
          </Link>

          {/* Mobile hamburger -> Sheet drawer */}
          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <button
                className="lg:hidden text-primary min-w-[44px] min-h-[44px] flex items-center justify-center"
                aria-label="Menu"
              >
                <Menu size={24} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-primary border-l-primary-cyan w-72 p-0">
              <nav className="flex flex-col pt-16">
                {links.map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    onClick={() => setMobileOpen(false)}
                    className="px-6 py-4 text-primary-foreground text-sm tracking-wider hover:bg-primary-cyan transition-colors min-h-[44px] flex items-center"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>

      {!isProductPage && (
        <Link
          to="/san-pham/combo-da-khuech-tan-tinh-dau"
          className="flex w-full items-center justify-center gap-2 bg-primary text-primary-foreground py-2 text-[11px] md:text-xl font-heading tracking-tight hover:bg-accent transition-colors border-t border-primary-foreground/10 min-h-[44px]"
        >
          <span>Cùng Memys, tạo ra bộ sản phẩm thuộc về riêng bạn</span>
          <ArrowRight size={18} className="animate-pulse" />
        </Link>
      )}
    </header>
  );
};

export default Header;
